import React from 'react';
import { AlertCircle, CheckCircle2, Info, XCircle } from 'lucide-react';
import { Alert as AlertUI, AlertDescription } from "@/components/ui/alert";

interface AlertProps {
  title?: string;
  message: string;
  variant?: 'default' | 'success' | 'error' | 'info';
  className?: string;
}

const variants = {
  default: {
    icon: AlertCircle,
    className: 'bg-primary/10 text-primary border-primary/20'
  },
  success: {
    icon: CheckCircle2,
    className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20'
  },
  error: {
    icon: XCircle,
    className: 'bg-red-500/10 text-red-400 border-red-500/20'
  },
  info: {
    icon: Info,
    className: 'bg-blue-500/10 text-blue-400 border-blue-500/20'
  }
};

export function Alert({
  title,
  message,
  variant = 'default',
  className = ''
}: AlertProps) {
  const { icon: Icon, className: variantClassName } = variants[variant];

  return (
    <AlertUI className={`${variantClassName} ${className}`}>
      <Icon className="h-4 w-4" />
      {title && <h5 className="font-medium mb-1">{title}</h5>}
      <AlertDescription>{message}</AlertDescription>
    </AlertUI>
  );
}